export const appID = 'jeppa-reviews';
export const appTitle = 'Jeppa Sport Reviews';
export const appURI =
  process.env.NODE_ENV === 'development'
    ? 'https://jeppa-back-4b44007b3145.herokuapp.com/api/'
    : 'https://jeppa-back-4b44007b3145.herokuapp.com/api/';
